export enum PlanUpgradeRequestChangeStatus {
    Approve = 'Approve',
    Reject = 'Reject'
}